import React, { useEffect } from "react";
import PartialApproveUi from "./PartialApproveUi";
import Layout from "../../../../Components/Layout/Layout";
import { Formik } from "formik";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { hidetoast, useDecodeToken } from "../../../../Utils/function";
import { useGetUsersQuery } from "../../../../store/Api/users";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { usePartialApproveAuditMutation } from "../../../../store/Api/audits";
const validationSchema = Yup.object({
  reason: Yup.string()
    .trim()
    .required("Please enter your Reason"),
   
  user_id: Yup.string().required("Please select an option"),
});
const PartialApprove = () => {
  const decodedToken = useDecodeToken();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [partialApprove] = usePartialApproveAuditMutation();
  const { id } = useParams();

  const location = useLocation();
  const { state } = location;
  const { data: userData } = useGetUsersQuery({
    search: "",
    limit: "",
    page: "",
    rrb_id: decodedToken?.role == 3 || decodedToken?.role == 4 ? state?.data?.data?.rrb_id : ""
  });
  const toast = useSelector((state) => state.toast);
  useEffect(() => {
    if (toast.message) {
      hidetoast();
    }
  }, [toast.message, dispatch]);
  const handleSubmit = async (values) => {
    const trimmedValues = Object.fromEntries(
      Object.entries(values).map(([key, value]) => [
        key,
        typeof value === "string" ? value.trim() : value,
      ])
    );
    
    try {
      const response = await partialApprove({ id: id, ...trimmedValues });
      if (response?.data?.success) {
        navigate("/audits");
      }
    } catch (error) {
      console.log(error, "Audit in error");
    }
  };
  return (
    <Layout>
      <Formik
        initialValues={{
          user_id: state?.data?.data?.user_id ?? "",
          reason: "",
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formik) => (
          <PartialApproveUi
            formik={formik}
            id={id}
            userData={userData}
            toast={toast}
          />
        )}
      </Formik>
    </Layout>
  );
};

export default PartialApprove;
